/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconIroning1 = createReactComponent("outline", "ironing-1", "IconIroning1", [["path", { "d": "M9 6h7.459a3 3 0 0 1 2.959 2.507l.577 3.464l.81 4.865a1 1 0 0 1 -.985 1.164h-16.82a7 7 0 0 1 7 -7h9.8", "key": "svg-0" }], ["path", { "d": "M12 15h.01", "key": "svg-1" }]]);

export { IconIroning1 as default };
//# sourceMappingURL=IconIroning1.mjs.map
